import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';

interface ITranslationsFilterProps {
  formik: FormikProps<any>;
  filterKeyOptions: Array<{ id: string | boolean; name: string }>;
  filterLanguageOptions: Array<{ id: string | boolean; name: string }>;
  filterIsEmptyTranslationOptions: Array<{
    id: string | boolean;
    name: string;
  }>;
}

export function TranslationsFilter(props: ITranslationsFilterProps) {
  const {
    formik,
    filterKeyOptions,
    filterLanguageOptions,
    filterIsEmptyTranslationOptions,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.key')}
          name="key"
          options={filterKeyOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.language')}
          name="language"
          options={filterLanguageOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.value')}
          name="emptyValue"
          options={filterIsEmptyTranslationOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
    </Grid>
  );
}
